<!-- @format -->

<div class="row event-detail-row">
  <div class="col-11 col-sm-10">
    <div class="row">
      <div class="col-3 col-xl-2">{{ studyEvent | studyEventDateRange }}</div>
      <div class="col-2 col-sm-1">{{ studyEvent | studyEventWeekdayOrInterval }}</div>
      <div class="col-2">{{ studyEvent | studyEventTimeRange }}</div>
      <div
        class="locations col-5"
        [ngClass]="{ 'col-sm-4 col-md-5 col-lg-6': cancelledEventCount > 0, 'col-sm-5 col-md-6': cancelledEventCount === 0 }">
        @if (allEventsExcludedOrCancelled) {
          <div>
            <span class="tiny-badge danger" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.CANCELLED"> </span>
          </div>
        }
        @if (!allEventsExcludedOrCancelled) {
          <div>
            @for (locationId of studyEvent?.locationIds; track locationId) {
              <div class="location-name">
                <sis-icon icon="pin-small"></sis-icon>
                @if (locationId | location | async; as location) {
                  <span class="location"> {{ location.building.name | localizedString }}, {{ location.name | localizedString }}</span>
                }
              </div>
            }
            @if (hasNoLocations) {
              <div class="no-location">
                <sis-icon icon="pin-small"></sis-icon>
                <span class="location" translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.NO_LOCATION"></span>
              </div>
            }
            @if (hasLocationOverrides) {
              <div class="irregularities">
                (<span translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.IRREGULAR_LOCATIONS"></span>)
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  @if (cancelledEventCount > 0 && !allEventsExcludedOrCancelled) {
    <div class="col-1 col-sm-2">
      <sis-icon icon="alert" color="danger"></sis-icon>
      <span class="cancelled-events">
        <span translate="SIS_COMPONENTS.COURSE_UNIT_REALISATION_STRUCTURE.CANCELLED_EVENTS"></span>
        ({{ cancelledEventCount }})
      </span>
    </div>
  }
</div>
@if (irregularEvents.length > 0) {
  <sis-study-sub-group-structure-study-event-exceptions
    [irregularEvents]="irregularEvents"
    [studyEventLocationIds]="studyEvent.locationIds"
    [studyEventTeacherIds]="teacherIds"
    [language]="language">
  </sis-study-sub-group-structure-study-event-exceptions>
}
